import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DirectRouteGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    const nav = this.router.getCurrentNavigation();
    if (nav?.trigger !== 'imperative') {
      // Direct browser URL entry or refresh — redirect to home,
      // which will navigate here again with skipLocationChange.
      return this.router.createUrlTree(['']);
    }
    return true;
  }
}
